import styled from 'styled-components';

export const CardsWrapper = styled.div`
  gap: 8px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(5, 40px);

  & > i {
    font-size: 30px;

    .selected {
      background-color: ${({ theme }) => theme.colors.black1};
      border: 1px solid ${({ theme }) => theme.colors.black9};
    }
  }

  .selected {
    background-color: ${({ theme }) => theme.colors.green1};
    border: 2px solid ${({ theme }) => theme.colors.green6};
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 40px);
  }
`;

export const ActivityTypeWrapper = styled.div`
  cursor: pointer;
  display: flex;
  border-radius: 8px;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  align-items: center;
  padding: 8px 16px;

  &:hover:not(.selected) {
    background-color: ${({ theme }) => theme.colors.black2};
  }
`;

export const NameWrapper = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`;
